import styled from 'styled-components';
import { bordaArredondar, espacamento } from '../../styles/constants/sizes';

export const JanelaEnquete = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  border-radius: 4px;
  padding: ${espacamento.medio}px;
  box-shadow: 0 5px 30px 0 rgb(0 0 0 / 50%);
  display: flex;
  width: 80%;
  max-width: 600px;
  flex-direction: column;

  div {
    max-height: 90vh;
  }

  iframe {
    max-width: 100%;
    max-height: 80vh;
  }

  img {
    object-fit: contain;
    overflow: hidden;
    max-height: 75vh;
  }
`;

export const TituloEnquete = styled.h4`
    font-size: 1.2em;
    border-bottom: 1px solid #dededd;
    padding-bottom: ${espacamento.extraPequeno}px;
    margin-top: 0;
    color: #828282;
`;
